import React from 'react'
import GitHubIcon from '@material-ui/icons/GitHub'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import TwitterIcon from '@material-ui/icons/Twitter'
import InstagramIcon from '@material-ui/icons/Instagram'
import { about } from '../../portfolio'
import './Footer.css'

export default function Social() {
    const { social } = about
    return (
        <div className='social'>
            {social && (
                <>
                    {social.github && (
                        <a
                            target='__blank'
                            href={social.github}
                            aria-label='github'
                            className='social_link link--icon'
                        >
                            <GitHubIcon />
                        </a>
                    )}

                    {social.linkedin && (
                        <a
                            target='__blank'
                            href={social.linkedin}
                            aria-label='linkedin'
                            className='social_link link--icon'
                        >
                            <LinkedInIcon />
                        </a>
                    )}
                    {social.instagram && (
                        <a
                            target='__blank'
                            href={social.instagram}
                            aria-label='instagram'
                            className='social_link link--icon'
                        >
                            <InstagramIcon />
                        </a>
                    )}
                    {social.twitter && (
                        <a
                            target='__blank'
                            href={social.twitter}
                            aria-label='twitter'
                            className='social_link link--icon'
                        >
                            <TwitterIcon />
                        </a>
                    )}
                </>
            )}
        </div>
    )
}
